module.exports = __webpack_public_path__ + "img/interactive-kiosks-portrait-landscape.de3b6089.webp";